(function($){

    if (typeof Drupal !== "undefined") {
        Drupal.behaviors.nodeShipment = {
            attach: function(context, settings) {
                init();
            }
        };
    } else {
        init();
    }

    function init() {

        $.widget( "ui.dialog", $.ui.dialog, {
            open: function() {
                let block = $(".node-type-shipment .field-images"),
                    item = block.find(".field-image__item"),
                    arrows = block.find(".arrows"),
                    dots = block.find(".field-image__dots");

                if ( item.length > 1 ) {
                    // arrows.css({
                    //     "opacity": 1,
                    //     "visibility": "visible",
                    // });

                    var galleryTop = new Swiper(".node-type-shipment .field-image__slider", {
                        wrapperClass: "field-image__slider-wrapper",
                        slideClass: "field-image__item",
                        slideActiveClass: "active",
                        updateOnWindowResize: true,
                        spaceBetween: 0,
                        slidesPerView: 1,
                        watchSlidesVisibility: true,
                        loop: true,
                        setWrapperSize: true,
                        watchOverflow: true,
                        observer: true,
                        observeParents: true,
                        observeSlideChildren: true,
                        navigation: {
                            nextEl: ".node-type-shipment .arrows__next",
                            prevEl: ".node-type-shipment .arrows__prev",
                            disabledClass: "arrows__arrow_disabled",
                        },
                        pagination: {
                            el: ".node-type-shipment .field-image__dots .dots",
                            dynamicBullets: true,
                            clickable: true,
                        }
                    });

                }

                $(".field-image__dots .dots").show();

                return this._super();
            },
            close: function () {
                $(".ui-dialog-wrapper, .autodialog-content").remove();
            }
        });

    }

    $(document).ready(function () {
        let block = $(".node-type-shipment .field-images"),
            item = block.find(".field-image__item"),
            arrows = block.find(".arrows"),
            dots = block.find(".field-image__dots");

        if ( item.length > 1 ) {
            // arrows.css({
            //     "opacity": 1,
            //     "visibility": "visible",
            // });

            var galleryTop = new Swiper(".node-type-shipment .field-image__slider", {
                wrapperClass: "field-image__slider-wrapper",
                slideClass: "field-image__item",
                slideActiveClass: "active",
                updateOnWindowResize: true,
                spaceBetween: 0,
                slidesPerView: 1,
                watchSlidesVisibility: true,
                loop: true,
                setWrapperSize: true,
                watchOverflow: true,
                observer: true,
                observeParents: true,
                observeSlideChildren: true,
                navigation: {
                    nextEl: ".node-type-shipment .arrows__next",
                    prevEl: ".node-type-shipment .arrows__prev",
                    disabledClass: "arrows__arrow_disabled",
                },
                pagination: {
                    el: ".node-type-shipment .field-image__dots .dots",
                    dynamicBullets: true,
                    clickable: true,
                }
            });

        }

        $(".field-image__dots .dots").show();
    });

})(jQuery);
